import { SegmentStatistique } from "./../../../models/SegmentStatistique";
import { ChartType, ChartDataSets } from "chart.js";
import { Label, BaseChartDirective } from "ng2-charts";
import { Component, Input, OnInit, ViewChild } from "@angular/core";
import { PortefeuilleDetail } from "src/app/fonds-propres/models/PortefeuilleDetail";
import * as pluginDataLabels from "chartjs-plugin-datalabels";

@Component({
  selector: "app-consommation-fonds-propres",
  templateUrl: "./consommation-fonds-propres.component.html",
  styleUrls: ["./consommation-fonds-propres.component.scss"],
})
export class ConsommationFondsPropresComponent implements OnInit {
  @Input("segmentStatistiques")
  set segmentStatistiques(value: SegmentStatistique[]) {
    console.log(value);
    this.formattedChartDatas(value);
  }

  constructor() {}
  totalCumulApr: number = 0;
  totalCumulFondpropre: number = 0;

  cumulCreanceSaines: number = 0;
  cumulCreanceEnSouffrance: number = 0;
  cumulProvisions: number = 0;
  cumulEngagementHorsBilan: number = 0;
  cumulCreanceNettes: number = 0;
  nombreLigneCredit: number = 0;

  donneeArry: any[] = [];
  libelleDateArry: any[] = [];
  pieChartLabels: Label[] = [];
  pieChartType: ChartType = "pie";
  public pieChartPlugins = [pluginDataLabels];
  pieChartData: ChartDataSets[] = [];
  @ViewChild(BaseChartDirective, { static: false }) chart: BaseChartDirective;

  ngOnInit() {}

  formattedChartDatas(data: SegmentStatistique[]) {
    this.totalCumulApr = 0;
    this.totalCumulFondpropre = 0;
    this.cumulCreanceSaines = 0;
    this.cumulCreanceEnSouffrance = 0;
    this.cumulProvisions = 0;
    this.cumulEngagementHorsBilan = 0;
    this.cumulCreanceNettes = 0;
    this.nombreLigneCredit = 0;
    this.donneeArry = [];
    this.libelleDateArry = [];
    this.pieChartLabels = [];
    if (data) {
      data.forEach((element) => {
        this.donneeArry.push(element.cumulFondpropre);
        this.libelleDateArry.push(element.codeSegment);
        this.totalCumulApr = this.totalCumulApr + element.cumulApr;
        this.totalCumulFondpropre =
          this.totalCumulFondpropre + element.cumulFondpropre;

        this.cumulCreanceSaines =
          this.cumulCreanceSaines + element.cumulCreanceSaines;
        this.cumulCreanceEnSouffrance =
          this.cumulCreanceEnSouffrance + element.cumulCreanceEnSouffrance;
        this.cumulProvisions = this.cumulProvisions + element.cumulProvisions;
        this.cumulEngagementHorsBilan =
          this.cumulEngagementHorsBilan + element.cumulEngagementHorsBilan;
        this.cumulCreanceNettes =
          this.cumulCreanceNettes + element.cumulCreanceNettes;
        this.nombreLigneCredit =
          this.nombreLigneCredit + element.nombreLigneCredit;
      });
    }

    this.pieChartData = this.donneeArry;
    this.pieChartLabels = this.libelleDateArry;
  }

  pieChartOptions = {
    responsive: true,
    legend: {
      position: "bottom",
    },
    title: {
      display: true,
      text: "Fonds propres par segmentation prudentielle",
    },
    tooltips: {
      enabled: true,
      callbacks: {
        label: function (tooltipItem, data) {
          let label = data.labels[tooltipItem.index];
          let value =
            data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];
          return (
            " " +
            label +
            ": " +
            Intl.NumberFormat("fr-FR", {
              maximumFractionDigits: 0,
              minimumFractionDigits: 0,
            }).format(Number(value))
          );
        },
      },
    },
    plugins: {
      legend: {
        display: true,
        position: "top",
      },
      datalabels: {
        formatter: (value, ctx) => {
          let sum = 0;
          let dataArr = ctx.chart.data.datasets[0].data;
          dataArr.map((data) => {
            sum += data;
          });
          let percentage = ((value * 100) / sum).toFixed(2) + "%";
          return percentage;
        },
        color: "#fff",
      },
    },
  };

  public pieChartColors = [
    {
      backgroundColor: [
        "#0074D9",
        "#FF4136",
        "#2ECC40",
        "#FF851B",
        "#7FDBFF",
        "#B10DC9",
        "#FFDC00",
        "#001f3f",
        "#39CCCC",
        "#01FF70",
        "#85144b",
        "#F012BE",
        "#3D9970",
        "#111111",
        "#AAAAAA",
      ],
    },
  ];

  downloadCanvas(event) {
    var anchor = event.target;
    anchor.href = document.getElementsByTagName("canvas")[0].toDataURL();
    anchor.download = "chart.png";
  }

  updateChart() {
    this.chart.chart.update(); // This re-renders the canvas element.
  }
}
